import { getMantenimiento, patchMantenimiento, PatchMantenimientoProps } from "@/services/maintenance.service";
import { GetMaintenanceResponse } from "./maintenance.schema";
import { getAxiosErrorMessage } from "@/utils/axios-error-message";
import { handlePermissionError } from "@/utils/permission-check";
import { toaster } from "@/components/ui/toaster";
import { FieldValues } from "react-hook-form";
import { NavigateFunction } from "react-router-dom";

export interface FetchFlagsHandlerProps {
  showLoad?: boolean;
  setLoadingFlags: (loading: boolean) => void;
  setFlags: (flags: GetMaintenanceResponse | null) => void;
  navigate: NavigateFunction;
  fetchPermissions: () => Promise<void>;
}

export const fetchFlagsHandler = async ({
  fetchPermissions,
  setLoadingFlags,
  setFlags,
  navigate,
  showLoad = true,
}: FetchFlagsHandlerProps) => {
  if (showLoad) setLoadingFlags(true);

  try {
    const response = await getMantenimiento();

    setFlags(response);
  } catch (error) {
    const errorMessage = getAxiosErrorMessage(
      error,
      "No se pudieron obtener las secciones.",
    );

    const handled = await handlePermissionError(
      error,
      navigate,
      fetchPermissions,
    );
    if (!handled) {
      toaster.create({
        type: "error",
        title: errorMessage,
      });
    }

    throw error;
  } finally {
    setLoadingFlags(false);
  }
};


export interface PatchFlagHandlerProps {
    setLoadingPatchFlag: (loading: boolean) => void;
    fetchFlags: () => Promise<void>
    navigate: NavigateFunction;
    fetchPermissions: () => Promise<void>;
    values: FieldValues
}

export const patchFlagHandler = async ({
    setLoadingPatchFlag,
    fetchFlags,
    values,
    navigate,
    fetchPermissions,
}: PatchFlagHandlerProps) => {


    try {
        setLoadingPatchFlag(true);

        const objToSend: PatchMantenimientoProps = {
            codigoModulo: values.codigoModulo,
            codigoSeccion: values.codigoSeccion,
            nuevoEstado: values.nuevoEstado,
        }

        await patchMantenimiento(objToSend);

        toaster.create({
            type: "success",
            title: `Se ha ${values.nuevoEstado ? "desactivado" : "activado"} el mantenimiento de la sección.`,
        });

        await fetchFlags();
    } catch (error) {
          const errorMessage = getAxiosErrorMessage(
      error,
      "No se ha podido activar/desactivar el mantenimiento de la sección.",
    );

    const handled = await handlePermissionError(
      error,
      navigate,
      fetchPermissions,
    );
    if (!handled) {
      toaster.create({
        type: "error",
        title: errorMessage,
      });
    }

    throw error;
    } finally {
        setLoadingPatchFlag(false);
    }
}